export const basis = [
    { value: 'fixed', name: 'Fixed' },
    { value: 'percent', name: 'Percent' },
    { value: 'total_production', name: 'Total Production' },
    { value: 'production_per_pickup', name: 'Production Per Pickup' },
    { value: 'production_per_day_with_pickup', name: 'Production Per Day With Pickup' },
];

export const splitPortion = [
    { value: 'gross_pay', name: 'Gross Pay' },
    { value: 'total_hauling', name: 'Total Hauling' },
    { value: 'total_advertising', name: 'Total Advertising' },
    { value: 'total_products', name: 'Total Products' },
];

export const paymentType = [
    { value: 'advance', name: 'Advance' },
    { value: 'settlement', name: 'Settlement' },
];
